import React from 'react';
import { motion } from 'framer-motion';
import { CartIcon } from './icons/CraftIcons';
import { trackAddToCart } from '../utils/metaPixel';
import { CHECKOUT } from '../data/offer';
type CtaButtonProps = {
  label: string;
  subLabel?: string;
  size?: 'md' | 'lg';
  className?: string;
  href?: string;
  /** Fires the Meta Pixel AddToCart event, then hands the shopper to Shopify. */
  isCheckout?: boolean;
};
export function CtaButton({
  label,
  subLabel,
  size = 'md',
  className = '',
  href = '#checkout',
  isCheckout = false
}: CtaButtonProps) {
  const pad = size === 'lg' ? 'px-6 py-4 sm:px-10 sm:py-5' : 'px-5 py-3';
  const text = size === 'lg' ? 'text-base sm:text-lg' : 'text-sm';
  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    if (!isCheckout) return;

    // Let modifier / middle clicks behave natively.
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;
    event.preventDefault();
    trackAddToCart({
      content_name: CHECKOUT.productName,
      content_ids: [CHECKOUT.variantId],
      content_type: 'product',
      value: CHECKOUT.value,
      currency: CHECKOUT.currency
    });

    // Small delay so the pixel request leaves before the redirect.
    window.setTimeout(() => {
      window.location.href = href;
    }, 250);
  };
  return <motion.a href={href} onClick={handleClick} whileHover={{
    y: -3,
    scale: 1.01
  }} whileTap={{
    y: 0,
    scale: 0.99
  }} transition={{
    type: 'spring',
    stiffness: 420,
    damping: 24
  }} className={`group flex w-full flex-col items-center gap-1 rounded-2xl border border-sage-deep bg-gradient-to-b from-[#7E9970] to-[#5F7654] text-center text-white shadow-[0_14px_26px_rgba(74,92,62,0.42),inset_0_1px_0_rgba(255,255,255,0.3)] outline-none focus-visible:ring-4 focus-visible:ring-sage/40 ${pad} ${className}`} data-id="element-69" data-mp="3jxqea7ptufue">
      <span className={`flex items-center justify-center gap-2.5 font-extrabold leading-tight ${text}`} data-id="element-70" data-mp="gg8804ppdgw3">
        <CartIcon className="h-5 w-5 shrink-0 transition-transform duration-300 group-hover:-rotate-6" data-id="element-71" data-mp="3mxgvgex9crde" />
        {label}
      </span>
      {subLabel ? <span className="text-[10px] font-medium uppercase tracking-wider text-white/85 sm:text-[11px]" data-id="element-72" data-mp="3hzxg1botq8jv">
          {subLabel}
        </span> : null}
    </motion.a>;
}